(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brimful-pdp-hair"]) return;
  try {
    

if (!customElements.get('brimful-reviews')) {
  customElements.define('brimful-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.cards = Array.from(this.querySelectorAll('[data-review-rating]'));
      this.filter = this.querySelector('[data-rating-filter]');
      this.status = this.querySelector('[data-review-status]');
      this.previous = this.querySelector('[data-review-previous]');
      this.next = this.querySelector('[data-review-next]');
      this.page = 0;
      this.pageSize = 10;
      this.filter.addEventListener('change', () => { this.page = 0; this.update(); });
      this.previous.addEventListener('click', () => { this.page--; this.update(true); });
      this.next.addEventListener('click', () => { this.page++; this.update(true); });
      this.querySelectorAll('[data-review-enhanced]').forEach(node => { node.hidden = false; });
      this.update();
    }
    update(moveFocus = false) {
      const matches = this.cards.filter(card => !this.filter.value || card.dataset.reviewRating === this.filter.value);
      const pages = Math.max(1, Math.ceil(matches.length / this.pageSize));
      this.page = Math.max(0, Math.min(this.page, pages - 1));
      const start = this.page * this.pageSize;
      const visible = new Set(matches.slice(start, start + this.pageSize));
      this.cards.forEach(card => { card.hidden = !visible.has(card); });
      this.status.textContent = this.status.dataset.template.replace('__START__', matches.length ? start + 1 : 0).replace('__END__', Math.min(start + this.pageSize, matches.length)).replace('__COUNT__', matches.length);
      this.querySelector('[data-review-page]').textContent = this.dataset.pageTemplate.replace('__PAGE__', this.page + 1).replace('__PAGES__', pages);
      this.querySelector('[data-review-empty]').hidden = matches.length > 0;
      this.previous.disabled = this.page === 0;
      this.next.disabled = this.page >= pages - 1;
      if (moveFocus && matches[start]) {
        const heading = matches[start].querySelector('h3');
        heading.focus({preventScroll:true});
        heading.scrollIntoView({block:'start', behavior:'auto'});
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brimful-pdp"]) return;
  try {
    

if (!customElements.get('brimful-reviews')) {
  customElements.define('brimful-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.cards = Array.from(this.querySelectorAll('[data-review-rating]'));
      this.filter = this.querySelector('[data-rating-filter]');
      this.status = this.querySelector('[data-review-status]');
      this.previous = this.querySelector('[data-review-previous]');
      this.next = this.querySelector('[data-review-next]');
      this.page = 0;
      this.pageSize = 10;
      this.filter.addEventListener('change', () => { this.page = 0; this.update(); });
      this.previous.addEventListener('click', () => { this.page--; this.update(true); });
      this.next.addEventListener('click', () => { this.page++; this.update(true); });
      this.querySelectorAll('[data-review-enhanced]').forEach(node => { node.hidden = false; });
      this.update();
    }
    update(moveFocus = false) {
      const matches = this.cards.filter(card => !this.filter.value || card.dataset.reviewRating === this.filter.value);
      const pages = Math.max(1, Math.ceil(matches.length / this.pageSize));
      this.page = Math.max(0, Math.min(this.page, pages - 1));
      const start = this.page * this.pageSize;
      const visible = new Set(matches.slice(start, start + this.pageSize));
      this.cards.forEach(card => { card.hidden = !visible.has(card); });
      this.status.textContent = this.status.dataset.template.replace('__START__', matches.length ? start + 1 : 0).replace('__END__', Math.min(start + this.pageSize, matches.length)).replace('__COUNT__', !this.filter.value && matches.length >= 300 ? '300+' : matches.length);
      this.querySelector('[data-review-page]').textContent = this.dataset.pageTemplate.replace('__PAGE__', this.page + 1).replace('__PAGES__', pages);
      this.querySelector('[data-review-empty]').hidden = matches.length > 0;
      this.previous.disabled = this.page === 0;
      this.next.disabled = this.page >= pages - 1;
      if (moveFocus && matches[start]) {
        const heading = matches[start].querySelector('h3');
        heading.focus({preventScroll:true});
        heading.scrollIntoView({block:'start', behavior:'auto'});
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
